import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Unprocessed' },
    { value: 2, label: 'Declined' },
    { value: 3, label: 'Accepted' },
    { value: 4, label: 'Waitlisted' },
  ],
});
